export const sso = {
  error: {
    back: "Back to login page",
    connectionError:
      "An error occurred while connecting to the STELAR platform",
    userNotExist:
      "The account <span>{{ email }}</span> does not exist in the STELAR platform. To create your account, please contact support",
    userDeactivated: "Your account is deactivated in the STELAR platform",
    support: {
      message: "To contact support, click this link",
      link: "Support",
    },
    title: "Connection error",
  },
};
